import { ExtensaoUsoListagemResults } from "../models/models";
import { STATUS_EXTENSAO_USO } from "./statusExtensaoUso";
import { isAdmin } from "../users/isAdmin";
import { isReguladorRegister } from "../users/isRegulador";
import {
  isRequesterReadRegister,
  isRequesterWriteRegister,
  isTecnicoExtensaoUso,
} from "../users/isRequester";

/** Após o regulatório enviar ao MAPA (ou extensão encerrada/cancelada). */
export function statusAposAprovacaoPeloRegulatorio(status: string | undefined): boolean {
  if (!status) return false;
  return (
    status === STATUS_EXTENSAO_USO.AguardandoMAPA ||
    status === STATUS_EXTENSAO_USO.AprovadoPeloMAPA ||
    status === STATUS_EXTENSAO_USO.ReprovadoPeloMAPA ||
    status === STATUS_EXTENSAO_USO.Cancelado
  );
}

export function isUltimaExtensaoDoRegistroNaListagem(
  row: ExtensaoUsoListagemResults,
  allRows: ExtensaoUsoListagemResults[]
): boolean {
  if (!row.extensaoUsoId) return true;
  const mesmas = allRows.filter(
    (r) => r.registroId === row.registroId && r.extensaoUsoId
  );
  if (mesmas.length === 0) return true;
  const maxId = Math.max(...mesmas.map((r) => r.extensaoUsoId!));
  return row.extensaoUsoId === maxId;
}

/**
 * Técnico e requisitante (escrita): só editam a extensão vigente e antes do envio ao MAPA.
 * Requisitante somente leitura: sempre visualização.
 */
export function deveExibirSomenteLeituraExtensaoUso(
  roles: string[],
  statusNormalizado: string,
  extensaoEhUltimaVersao: boolean | null,
  forcarVisualizar: boolean
): boolean {
  if (forcarVisualizar) return true;
  if (isRequesterReadRegister(roles) && !isRequesterWriteRegister(roles)) return true;
  if (isAdmin(roles) || isReguladorRegister(roles)) return false;

  const tecnicoOuReqEscrita =
    isTecnicoExtensaoUso(roles) || isRequesterWriteRegister(roles);
  if (!tecnicoOuReqEscrita) return false;

  if (extensaoEhUltimaVersao === null || extensaoEhUltimaVersao === false) return true;
  if (statusNormalizado === STATUS_EXTENSAO_USO.AguardandoRegulatorio) return true;
  if (statusAposAprovacaoPeloRegulatorio(statusNormalizado)) return true;
  return false;
}
